module.exports = __webpack_public_path__ + "img/2.71cfac74.jpg";